import { render, staticRenderFns } from "./Dashboardnew.vue?vue&type=template&id=0f9640a6&scoped=true"
import script from "./Dashboardnew.vue?vue&type=script&lang=js"
export * from "./Dashboardnew.vue?vue&type=script&lang=js"
import style0 from "./Dashboardnew.vue?vue&type=style&index=0&id=0f9640a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9640a6",
  null
  
)

export default component.exports